module.exports = __webpack_public_path__ + "media/images/spacer-e613c79ecb0dae02d27b537a715b8baa.gif";